import { Header } from "../components/header";
import LeavesLeft from "../assets/leaves-left.png";
import Tomatoes from "../assets/tomatoes.png";
import MangroveGreenPeas from "../assets/mangrove-green-peas.png";
import MangroveSweetCorn from "../assets/mangrove-sweet-corn.png";
import MangroveSardineCan from "../assets/mangrove-sardines-can.png";
import MangroveBakedBeans from "../assets/mangrove-beans-can.png";
import MangroveCanMackerel from "../assets/mangrove-can-mackerel.png";
import FullColorFlavorImg from "../assets/full-color-flavor.png";
import Beans from "../assets/beans.png";
import Corn from "../assets/corn.png";
import MangroveProducts from "../assets/mangroove-products.png";
import Peas from "../assets/peas.png";
import PepperNut from "../assets/pepper-nut.png";
import Carousel from "react-multi-carousel";
import React, { useEffect, useState } from "react";
import { Footer } from "../components/footer";
import { trackPageView } from "../utils/segment";
import { toast } from "react-toastify";
import { createClient } from "contentful";
import { PageLoadingShimmer } from "../components/page-loading";
import { RecipesDetailModal } from "../components/recipes-details";

export function NewLandingPage() {
  const [recipes, setRecipes] = useState([]);
  const [pageLoading, setPageLoading] = useState(true);
  const [selectedRecipe, setSelectedRecipe] = useState(null);

  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3,
      slidesToSlide: 3, // optional, default to 1.
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2,
      slidesToSlide: 2, // optional, default to 1.
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
      slidesToSlide: 1, // optional, default to 1.
    },
  };

  const client = createClient({
    space: process.env.REACT_APP_CONTENTFUL_SPACE_ID,
    accessToken: process.env.REACT_APP_CONTENTFUL_API_KEY,
  });

  const fetchRecipes = async () => {
    try {
      const { items } = await client.getEntries({
        content_type: "recipes",
        order: "sys.createdAt",
      });
      setRecipes(items.splice(0, 5));
      setPageLoading(false);
    } catch (error) {
      console.log("eree", error);
      toast.error("There was a problem fetching recipes");
      setPageLoading(false);
    }
  };

  useEffect(() => {
    const hash = window.location.hash;
    if (hash) {
      // Wait a bit in case the DOM hasn't rendered the section yet
      setTimeout(() => {
        const element = document.getElementById(hash.substring(1));
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
      }, 100); // 100ms delay to ensure content is mounted
    }
  }, []);

  useEffect(() => {
    trackPageView("Viewed Landing Page");
    fetchRecipes();
    // eslint-disable-next-line
  }, []);

  return (
    <div className='new-landing-page'>
      {pageLoading ? <PageLoadingShimmer overlay /> : null}
      <Header />

      {/* Modern Hero Section */}
      <div className='modern-hero-section'>
        <div className='hero-content-wrapper'>
          <div className='hero-badge'>
            <i className='fas fa-leaf'></i>
            <span>Premium Quality</span>
          </div>
          <h1 className='hero-main-title'>
            Taste the <span className='gradient-accent'>Mangrove Standard</span>
          </h1>
          <p className='hero-description'>
            Discover our premium collection of tropical ingredients, carefully
            sourced and processed to bring you the authentic flavors of the
            tropics. From traditional staples to exotic spices, experience the
            richness of tropical cuisine.
          </p>
          <div className='hero-actions'>
            <a href='/where-to-buy' className='primary-action-btn'>
              <i className='fas fa-map-marker-alt'></i>
              Find Stores Near You
            </a>
          </div>
        </div>
        <div className='hero-visual-elements'>
          <div className='floating-ingredients'>
            <div className='ingredient-item ingredient-1'>
              <img src={Tomatoes} alt='Tomatoes' />
            </div>
            <div className='ingredient-item ingredient-2'>
              <img src={Beans} alt='Beans' />
            </div>
            <div className='ingredient-item ingredient-3'>
              <img src={Corn} alt='Corn' />
            </div>
            <div className='ingredient-item ingredient-4'>
              <img src={Peas} alt='Peas' />
            </div>
            <div className='ingredient-item ingredient-5'>
              <img src={PepperNut} alt='Pepper Nut' />
            </div>
            <div className='ingredient-item ingredient-6'>
              <img src={FullColorFlavorImg} alt='Full Color Flavor' />
            </div>
          </div>
        </div>
      </div>
      {/* Enhanced Products Showcase */}
      <div className='enhanced-products-showcase' id='products-range'>
        <div className='showcase-header'>
          <h2 className='showcase-title'>Our Premium Collection</h2>
          <p className='showcase-subtitle'>
            Carefully selected ingredients from the finest tropical sources
          </p>
        </div>
        <div className='products-grid'>
          <div className='product-card'>
            <div className='product-image'>
              <img src={MangroveSweetCorn} alt='Sweet Corn' />
            </div>
            <h3 className='product-name'>Sweet Corn</h3>
            <p className='product-description'>
              Premium quality sweet corn, perfect for any meal
            </p>
          </div>
          <div className='product-card'>
            <div className='product-image'>
              <img src={MangroveSardineCan} alt='Sardines' />
            </div>
            <h3 className='product-name'>Sardines</h3>
            <p className='product-description'>
              Rich in omega-3, our sardines are a healthy choice
            </p>
          </div>
          <div className='product-card'>
            <div className='product-image'>
              <img src={MangroveBakedBeans} alt='Baked Beans' />
            </div>
            <h3 className='product-name'>Baked Beans</h3>
            <p className='product-description'>
              Traditional baked beans with authentic tropical flavor
            </p>
          </div>
          <div className='product-card'>
            <div className='product-image'>
              <img src={MangroveGreenPeas} alt='Green Peas' />
            </div>
            <h3 className='product-name'>Green Peas</h3>
            <p className='product-description'>
              Fresh green peas, rich in vitamins and minerals
            </p>
          </div>
          <div className='product-card'>
            <div className='product-image'>
              <img src={MangroveCanMackerel} alt='Mackerel' />
            </div>
            <h3 className='product-name'>Mackerel</h3>
            <p className='product-description'>
              Premium mackerel, a great source of protein
            </p>
          </div>
        </div>
      </div>
      {/* Modern About Section */}
      <div className='modern-about-section' id='about-us'>
        <div className='about-content-wrapper'>
          <div className='about-text-content'>
            <div className='about-badge'>
              <i className='fas fa-heart'></i>
              <span>Our Story</span>
            </div>
            <h2 className='about-main-title'>About Mangrove Foods</h2>
            <p className='about-description'>
              Everyone at Mangrove Foods works hard to bring you high-quality
              ingredients from across the tropics direct to your door. From rice
              and traditional flours to palm oil and fine spices, our passion
              for food is in every colourful bite.
            </p>
            <div className='about-features'>
              <div className='feature-item'>
                <div className='feature-icon'>
                  <i className='fas fa-award'></i>
                </div>
                <span className='feature-text'>Premium Quality Standards</span>
              </div>
              <div className='feature-item'>
                <div className='feature-icon'>
                  <i className='fas fa-globe'></i>
                </div>
                <span className='feature-text'>
                  Sourced from Tropical Regions
                </span>
              </div>
              <div className='feature-item'>
                <div className='feature-icon'>
                  <i className='fas fa-leaf'></i>
                </div>
                <span className='feature-text'>
                  Natural & Authentic Flavors
                </span>
              </div>
            </div>
          </div>
          <div className='about-visual-content'>
            <div className='main-product-showcase'>
              <img src={MangroveProducts} alt='Mangrove Products' />
            </div>
            <div className='floating-decorations'>
              <div className='decoration-item decoration-1'>
                <img src={Peas} alt='Peas' />
              </div>
              <div className='decoration-item decoration-2'>
                <img src={PepperNut} alt='Pepper Nut' />
              </div>
              <div className='decoration-item decoration-3'>
                <img src={LeavesLeft} alt='Leaves' />
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Enhanced Recipes Section */}
      <div className='enhanced-recipes-section'>
        <div className='recipes-header'>
          <h2 className='recipes-title'>Inspiring Recipes</h2>
          <p className='recipes-subtitle'>
            Discover delicious ways to use our premium ingredients
          </p>
        </div>
        <div className='recipes-carousel-wrapper'>
          <Carousel
            arrows={false}
            autoPlay={true}
            autoPlaySpeed={5000}
            centerMode={false}
            draggable={true}
            showDots={true}
            responsive={responsive}
            dotListClass='custom-dot-list-style'
            renderDotsOutside={true}
            infinite={true}
          >
            {recipes.map((recipe, key) => (
              <div className='recipe-card' key={key}>
                <div className='recipe-image-container'>
                  <img
                    src={recipe.fields.foodImage.fields.file.url}
                    alt={recipe.fields.foodImage.fields.title}
                    className='recipe-image'
                  />
                </div>
                <div className='recipe-content'>
                  <h3 className='recipe-title'>{recipe.fields.foodName}</h3>
                  <p className='recipe-description'>
                    {recipe.fields.description}
                  </p>
                  <button
                    className='recipe-action-btn'
                    data-bs-toggle='modal'
                    data-bs-target='#recipe-details-modal'
                    onClick={() => setSelectedRecipe(recipe)}
                  >
                    <span>View Recipe</span>
                    <i className='fas fa-arrow-right'></i>
                  </button>
                </div>
              </div>
            ))}
          </Carousel>
        </div>

        {recipes.length ? (
          <div className='view-all-recipes-container'>
            <button
              className='view-all-btn'
              onClick={() => (window.location.href = "/recipes")}
            >
              <span>Explore All Recipes</span>
              <i className='fas fa-arrow-right'></i>
            </button>
          </div>
        ) : null}
      </div>

      <Footer />
      <RecipesDetailModal recipe={selectedRecipe} />
    </div>
  );
}
